// Período de uma meta. As datas são salvas como meia-noite UTC do dia escolhido
// (ex.: 2026-09-30T00:00:00+00), que no Brasil cai às 21h do dia anterior; comparar
// direto com isso deixava as vendas do último dia fora da meta.
// Aqui vale o dia do calendário: do início do primeiro dia ao fim do último, no fuso local.

type Periodo = { start_date: string; end_date: string };

const diaLocal = (valor: string, fimDoDia: boolean): Date => {
    const [a, m, d] = valor.slice(0, 10).split('-').map(Number);
    return fimDoDia ? new Date(a, m - 1, d, 23, 59, 59, 999) : new Date(a, m - 1, d);
};

export function periodoMeta(meta: Periodo): { inicio: Date; fim: Date } {
    return { inicio: diaLocal(meta.start_date, false), fim: diaLocal(meta.end_date, true) };
}

export function dentroDaMeta(data: string | Date, meta: Periodo): boolean {
    const t = new Date(data).getTime();
    const { inicio, fim } = periodoMeta(meta);
    return t >= inicio.getTime() && t <= fim.getTime();
}
